export default __webpack_public_path__ + "static/media/49.210fa563.jpg";